import { useCallback, useEffect, useState } from 'react';
import { usePixKeyResend } from '../usePixKeyResend';
import { useValidatePixKey } from '../useValidatePixKey';
export function usePixKeyConfirmation({ key, keyType, protocolId, onSuccess, onError, }) {
    const [error, setError] = useState(null);
    const [currentProtocolId, setCurrentProtocolId] = useState(protocolId);
    useEffect(() => {
        setCurrentProtocolId(protocolId);
    }, [protocolId]);
    const handleError = useCallback((errorMessage) => {
        setError(errorMessage);
        onError(errorMessage);
    }, [onError]);
    const handleResendSuccess = useCallback((newProtocolId) => {
        setCurrentProtocolId(newProtocolId);
    }, []);
    const { verificationCode, isValidationLoading, error: validationError, handleVerificationCodeChange, handleValidateCode, } = useValidatePixKey({
        key,
        keyType,
        protocolId: currentProtocolId,
        onSuccess,
        onError: handleError,
    });
    const { isResendLoading, canResend, timeRemaining, handleResendCode: resendHandleResendCode, } = usePixKeyResend({
        key,
        keyType,
        protocolId: currentProtocolId,
        onError: handleError,
        onResendSuccess: handleResendSuccess,
    });
    const handleResendCode = useCallback(() => {
        resendHandleResendCode();
        setError(null);
    }, [resendHandleResendCode]);
    const finalError = error || validationError;
    return {
        verificationCode,
        isValidationLoading,
        isResendLoading,
        canResend,
        timeRemaining,
        error: finalError,
        handleVerificationCodeChange,
        handleValidateCode,
        handleResendCode,
    };
}
